// Generated by scripts/write-show-me-the-coin-replay-fixtures.ts.
// Do not edit manually.

import type { ShowMeTheCoinReplayEventType } from "./event-adapter";

export interface ShowMeTheCoinReplayFixturePlayer {
  readonly id: string;
  readonly name: string;
  readonly role: "host" | "player";
}

export interface ShowMeTheCoinReplayFixtureEvent {
  readonly sequenceNumber: number;
  readonly eventType: ShowMeTheCoinReplayEventType;
  readonly userId: string;
  readonly payload: Record<string, unknown>;
}

export interface ShowMeTheCoinReplayFixture {
  readonly schemaVersion: 1;
  readonly gameType: "show-me-the-coin";
  readonly scenario: string;
  readonly source: "generated";
  readonly capturedAt: string;
  readonly players: readonly ShowMeTheCoinReplayFixturePlayer[];
  readonly events: readonly ShowMeTheCoinReplayFixtureEvent[];
  readonly notes: readonly string[];
}

export const SHOW_ME_THE_COIN_REPLAY_FIXTURES: Record<
  string,
  ShowMeTheCoinReplayFixture
> = {
  "heuristic-2p": {
    schemaVersion: 1,
    gameType: "show-me-the-coin",
    scenario: "heuristic-2p",
    source: "generated",
    capturedAt: "2026-06-24T00:00:00.000Z",
    players: [
      {
        id: "p1",
        name: "선 (휴리스틱·고가)",
        role: "host",
      },
      {
        id: "p2",
        name: "후 (휴리스틱·저가)",
        role: "player",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "p1",
        payload: {
          state: {
            gameId: "heuristic-2p",
            players: [
              {
                playerId: "p1",
                label: "선",
              },
              {
                playerId: "p2",
                label: "후",
              },
            ],
            phase: "submit-lead",
            round: 0,
            leadPlayerId: "p1",
            currentPlayerId: "p1",
            inventory: {
              p1: {
                "10": 30,
                "50": 10,
                "100": 7,
                "500": 3,
              },
              p2: {
                "10": 30,
                "50": 10,
                "100": 7,
                "500": 3,
              },
            },
            chips: {
              p1: 9,
              p2: 9,
            },
            submission: {
              p1: null,
              p2: null,
            },
            pot: 2,
            contributed: {
              p1: 1,
              p2: 1,
            },
            raisesUsed: 0,
            lastAggressorId: null,
            lastRound: null,
            winnerId: null,
            lastAction: null,
            moveNumber: 0,
          },
        },
      },
      {
        sequenceNumber: 2,
        eventType: "SubmitCoins",
        userId: "p1",
        payload: {
          playerId: "p1",
          coins: [500, 500, 500],
          moveNumber: 0,
        },
      },
      {
        sequenceNumber: 3,
        eventType: "SubmitCoins",
        userId: "p2",
        payload: {
          playerId: "p2",
          coins: [10, 10, 10],
          moveNumber: 1,
        },
      },
      {
        sequenceNumber: 4,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "check",
          moveNumber: 2,
        },
      },
      {
        sequenceNumber: 5,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "check",
          moveNumber: 3,
        },
      },
      {
        sequenceNumber: 6,
        eventType: "SubmitCoins",
        userId: "p2",
        payload: {
          playerId: "p2",
          coins: [10, 10, 10],
          moveNumber: 4,
        },
      },
      {
        sequenceNumber: 7,
        eventType: "SubmitCoins",
        userId: "p1",
        payload: {
          playerId: "p1",
          coins: [100, 100, 100],
          moveNumber: 5,
        },
      },
      {
        sequenceNumber: 8,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "check",
          moveNumber: 6,
        },
      },
      {
        sequenceNumber: 9,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "check",
          moveNumber: 7,
        },
      },
      {
        sequenceNumber: 10,
        eventType: "SubmitCoins",
        userId: "p1",
        payload: {
          playerId: "p1",
          coins: [100, 100, 100],
          moveNumber: 8,
        },
      },
      {
        sequenceNumber: 11,
        eventType: "SubmitCoins",
        userId: "p2",
        payload: {
          playerId: "p2",
          coins: [10, 10, 10],
          moveNumber: 9,
        },
      },
      {
        sequenceNumber: 12,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "check",
          moveNumber: 10,
        },
      },
      {
        sequenceNumber: 13,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "check",
          moveNumber: 11,
        },
      },
      {
        sequenceNumber: 14,
        eventType: "SubmitCoins",
        userId: "p2",
        payload: {
          playerId: "p2",
          coins: [10, 10, 10],
          moveNumber: 12,
        },
      },
      {
        sequenceNumber: 15,
        eventType: "SubmitCoins",
        userId: "p1",
        payload: {
          playerId: "p1",
          coins: [100, 50, 50],
          moveNumber: 13,
        },
      },
      {
        sequenceNumber: 16,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "check",
          moveNumber: 14,
        },
      },
      {
        sequenceNumber: 17,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 15,
        },
      },
      {
        sequenceNumber: 18,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 16,
        },
      },
      {
        sequenceNumber: 19,
        eventType: "SubmitCoins",
        userId: "p1",
        payload: {
          playerId: "p1",
          coins: [50, 50, 50],
          moveNumber: 17,
        },
      },
      {
        sequenceNumber: 20,
        eventType: "SubmitCoins",
        userId: "p2",
        payload: {
          playerId: "p2",
          coins: [10, 10, 10],
          moveNumber: 18,
        },
      },
      {
        sequenceNumber: 21,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 19,
        },
      },
      {
        sequenceNumber: 22,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 20,
        },
      },
      {
        sequenceNumber: 23,
        eventType: "SubmitCoins",
        userId: "p2",
        payload: {
          playerId: "p2",
          coins: [10, 10, 10],
          moveNumber: 21,
        },
      },
      {
        sequenceNumber: 24,
        eventType: "SubmitCoins",
        userId: "p1",
        payload: {
          playerId: "p1",
          coins: [50, 50, 50],
          moveNumber: 22,
        },
      },
      {
        sequenceNumber: 25,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "check",
          moveNumber: 23,
        },
      },
      {
        sequenceNumber: 26,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 24,
        },
      },
      {
        sequenceNumber: 27,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 25,
        },
      },
      {
        sequenceNumber: 28,
        eventType: "SubmitCoins",
        userId: "p1",
        payload: {
          playerId: "p1",
          coins: [50, 50, 10],
          moveNumber: 26,
        },
      },
      {
        sequenceNumber: 29,
        eventType: "SubmitCoins",
        userId: "p2",
        payload: {
          playerId: "p2",
          coins: [10, 10, 10],
          moveNumber: 27,
        },
      },
      {
        sequenceNumber: 30,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 28,
        },
      },
      {
        sequenceNumber: 31,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 29,
        },
      },
      {
        sequenceNumber: 32,
        eventType: "SubmitCoins",
        userId: "p2",
        payload: {
          playerId: "p2",
          coins: [10, 10, 10],
          moveNumber: 30,
        },
      },
      {
        sequenceNumber: 33,
        eventType: "SubmitCoins",
        userId: "p1",
        payload: {
          playerId: "p1",
          coins: [10, 10, 10],
          moveNumber: 31,
        },
      },
      {
        sequenceNumber: 34,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "check",
          moveNumber: 32,
        },
      },
      {
        sequenceNumber: 35,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 33,
        },
      },
      {
        sequenceNumber: 36,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 34,
        },
      },
      {
        sequenceNumber: 37,
        eventType: "SubmitCoins",
        userId: "p1",
        payload: {
          playerId: "p1",
          coins: [10, 10, 10],
          moveNumber: 35,
        },
      },
      {
        sequenceNumber: 38,
        eventType: "SubmitCoins",
        userId: "p2",
        payload: {
          playerId: "p2",
          coins: [10, 10, 10],
          moveNumber: 36,
        },
      },
      {
        sequenceNumber: 39,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 37,
        },
      },
      {
        sequenceNumber: 40,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 38,
        },
      },
      {
        sequenceNumber: 41,
        eventType: "SubmitCoins",
        userId: "p2",
        payload: {
          playerId: "p2",
          coins: [10, 10, 10],
          moveNumber: 39,
        },
      },
      {
        sequenceNumber: 42,
        eventType: "SubmitCoins",
        userId: "p1",
        payload: {
          playerId: "p1",
          coins: [10, 10, 10],
          moveNumber: 40,
        },
      },
      {
        sequenceNumber: 43,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "check",
          moveNumber: 41,
        },
      },
      {
        sequenceNumber: 44,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 42,
        },
      },
      {
        sequenceNumber: 45,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 43,
        },
      },
    ],
    notes: [
      "쇼 미 더 코인은 숨김정보 게임 — 코인 가치·보유 잔량은 서버 권위. 픽스처 init은 양측 코인 전체(복기용)를 담고, 화면은 상대 보유/제출 가치를 마스킹(개수만)한다.",
      "공정 휴리스틱(no-oracle): 봇은 마스킹된 뷰만 사용(상대 코인 안 보임). p2=소극적(체크·압박 시 폴드), p1=압박(초반 쇼다운으로 가치 공개 → 이후 벳으로 폴드 유도). 코인 가치는 동일 보유로 보존되므로 승부는 칩 흐름(폴드)으로 결정 → p1이 p2 칩을 0으로.",
      "결과: 44수, 쇼다운 3 + 폴드 7 → 선(p1) 승리 (10라운드).",
    ],
  },
};
